import apiClient from "./http";
import { Response } from "../entities/Response";
import {PackageRecord} from "../entities/PackageRecord";
import {PackageParam} from "../entities/PackageTemplate";
import Page, {PageList} from "../entities/Page";
import {DeployParam} from "../entities/DeployTemplate";
import {DeployRecord} from "../entities/DeployRecord";
import {DeployServerInfo} from "../entities/ServiceInfo";

export interface BuildPackageProps {
    appKey: string;
    env: string;
    param?: PackageParam;
    packageName?: string;
}

export interface DeployPackageProps {
    // packageRecord不为空时，当做基于包部署
    packageRecord?: PackageRecord | null;
    packageRequest?: BuildPackageProps;
    deployParam: DeployParam;
    ips: string[];
    releaseNote?: string;
}

export default class DeployService {

    static async continueDeploy(request: {deployRecordId: number, ips: string[]}): Promise<Response<DeployRecord>> {
        return await apiClient.post("/service/deploy/execute", request);
    }

    static async deploy(request: DeployPackageProps, gray: boolean): Promise<Response<DeployRecord>> {
        if (gray) {
            return await apiClient.post("/service/deploy/execute/gray", request);
        }
        return await apiClient.post("/service/deploy/execute", request);
    }

    static async rollback(request: {deployRecordId: number}) : Promise<Response<any>> {
        return await apiClient.post("/service/deploy/rollback", request);
    }

    static async listDeployRecords(request: { page: Page, appKey: string, env: string }) : Promise<Response<PageList<DeployRecord>> > {
        return await apiClient.post("/service/deploy/record/list", request);
    }

    static async getDeployRecord(request: { id: number }) : Promise<Response<DeployRecord>> {
        return await apiClient.post("/service/deploy/record/get", request);
    }

    static async listDeployServers(request: { appKey: string, env: string }) : Promise<Response<DeployServerInfo[]>> {
        return await apiClient.post("/service/deploy/server/list", request);
    }

    static async markSuccessful(param: { id: number, rollback: boolean }) : Promise<Response<DeployRecord>> {
        return await apiClient.post("/service/deploy/record/mark/successful", param);
    }
}
